import { makeStyles } from "@mui/styles";

const useStyles: any = makeStyles(() => ({
  dialogTitle: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: "16px",
    padding: "12px 16px",
    borderBottom: "1px solid #d5d2d5",
    backgroundColor: "#f6f6f7"
  },

  titleText: {
    fontSize: "16px",
    fontWeight: 500,
    color: "#4b1c46"
  },

  dialogContent: {
    display: "flex",
    flexDirection: "column",
    gap: "20px",
    padding: "16px",
    // MUI zeroes padding-top on a DialogContent that follows a DialogTitle
    // (`.MuiDialogTitle-root + .MuiDialogContent-root`); that rule outranks a
    // single class, so restore it at matching specificity.
    "&.MuiDialogContent-root": {
      paddingTop: "20px"
    }
  },

  hint: {
    fontSize: "12px",
    color: "#8f8a8f"
  }
}));

export default useStyles;
